var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.417 5.553a3.03 3.03 0 103.03 3.03 3.033 3.033 0 00-3.03-3.03zm0 5.06a2.03 2.03 0 112.03-2.03 2.03 2.03 0 01-2.03 2.03zM27.985 3H17.661a2.03 2.03 0 00-1.436.595L1.297 18.523a1.015 1.015 0 000 1.435l10.768 10.768a1.015 1.015 0 001.412.022l14.881-13.951A2.03 2.03 0 0029 15.316V4.015A1.015 1.015 0 0027.985 3zm-.311 13.067L12.793 30.02l-.01.004a.014.014 0 01-.011-.004L2.003 19.25 16.932 4.3a1.036 1.036 0 01.728-.3h10.324L28 15.316a1.033 1.033 0 01-.326.751z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--tag-outline-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'TagOutlineIcon';
export default Icon;